/* tslint:disable */
import { Injectable } from '@angular/core';
import { Email } from '../../models/Email';
import { RoleData } from '../../models/RoleData';
import { UserData } from '../../models/UserData';
import { UserRole } from '../../models/UserRole';
import { Partner } from '../../models/Partner';
import { StandardDiscount } from '../../models/StandardDiscount';
import { Product } from '../../models/Product';
import { ProductImage } from '../../models/ProductImage';
import { Order } from '../../models/Order';
import { OrderItem } from '../../models/OrderItem';
import { Configuration } from '../../models/Configuration';
import { Commission } from '../../models/Commission';
import { Activation } from '../../models/Activation';
import { Payment } from '../../models/Payment';
import { Card } from '../../models/Card';
import { AgentCommission } from '../../models/AgentCommission';
import { BankTransaction } from '../../models/BankTransaction';
import { Upload } from '../../models/Upload';
import { TermsAndCondition } from '../../models/TermsAndCondition';
import { CommissionUpload } from '../../models/CommissionUpload';
import { Discount } from '../../models/Discount';
import { DiscountRequest } from '../../models/DiscountRequest';
import { OtherOrder } from '../../models/OtherOrder';
import { OtherOrderItem } from '../../models/OtherOrderItem';
import { OtherPayment } from '../../models/OtherPayment';
import { VolumeDiscount } from '../../models/VolumeDiscount';
import { VolumeDiscountRate } from '../../models/VolumeDiscountRate';
import { VolumeDiscountRateRequest } from '../../models/VolumeDiscountRateRequest';
import { AuditTrail } from '../../models/AuditTrail';
import { DiscountLimit } from '../../models/DiscountLimit';
import { UserPassword } from '../../models/UserPassword';
import { AmazonS3 } from '../../models/AmazonS3';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    Email: Email,
    RoleData: RoleData,
    UserData: UserData,
    UserRole: UserRole,
    Partner: Partner,
    StandardDiscount: StandardDiscount,
    Product: Product,
    ProductImage: ProductImage,
    Order: Order,
    OrderItem: OrderItem,
    Configuration: Configuration,
    Commission: Commission,
    Activation: Activation,
    Payment: Payment,
    Card: Card,
    AgentCommission: AgentCommission,
    BankTransaction: BankTransaction,
    Upload: Upload,
    TermsAndCondition: TermsAndCondition,
    CommissionUpload: CommissionUpload,
    Discount: Discount,
    DiscountRequest: DiscountRequest,
    OtherOrder: OtherOrder,
    OtherOrderItem: OtherOrderItem,
    OtherPayment: OtherPayment,
    VolumeDiscount: VolumeDiscount,
    VolumeDiscountRate: VolumeDiscountRate,
    VolumeDiscountRateRequest: VolumeDiscountRateRequest,
    AuditTrail: AuditTrail,
    DiscountLimit: DiscountLimit,
    UserPassword: UserPassword,
    AmazonS3: AmazonS3,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}
